import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const validationRequests = {}

validationRequests.ValidatePINActivateUser = (data) => {
  return axios.post(
    AppUrls.ValidatePINActivateUser,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

validationRequests.ValidateCAPTCHA = (data) => {
  return axios.post(
    AppUrls.ValidateCAPTCHA,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

validationRequests.ValidatePINChangePassword = (data) => {
  return axios.post(
    AppUrls.ValidatePINChangePassword,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

validationRequests.SendDocumentValidation = (data) => {
  return axios.post(
    AppUrls.SendDocumentValidation,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}